<template>
  <div v-if="!profitlossMode || !profitlossShowHistory" class="ProfitLosses">
    <h3 class="heading-lined">{{ $t("content.profit_losses") }}</h3>
    <table class="Table">
      <colgroup>
        <col width="20%" />
        <col width="40%" />
        <col width="40%" v-if="!incognitoMode" />
      </colgroup>
      <tr class="Table__Row">
        <td class="Table__Range">{{ $t("global.last_hour") }}</td>
        <td :class="isNegative(changePercFromHourAgo_display)">
          {{ changePercFromHourAgo_display.toFixed(2) }}%
        </td>
        <td
          :class="isNegative(changePercFromHourAgo_display)"
          v-if="!incognitoMode"
        >
          {{ formatMoney(changeFromHourAgo_display) }}
        </td>
      </tr>
      <tr class="Table__Row">
        <td class="Table__Range">{{ $t("global.last_24_hour") }}</td>
        <td :class="isNegative(changePercFrom24HoursAgo_display)">
          {{ changePercFrom24HoursAgo_display.toFixed(2) }}%
        </td>
        <td :class="isNegative(changePercFrom24HoursAgo_display)" v-if="!incognitoMode">
          {{ formatMoney(changeFrom24HoursAgo_display) }}
        </td>
      </tr>
      <tr class="Table__Row">
        <td class="Table__Range">{{ $t("global.last_7_days") }}</td>
        <td :class="isNegative(changePercFrom7DaysAgo_display)">
          {{ changePercFrom7DaysAgo_display.toFixed(2) }}%
        </td>
        <td :class="isNegative(changePercFrom7DaysAgo_display)" v-if="!incognitoMode">
          {{ formatMoney(changeFrom7DaysAgo_display) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NumbersMixin from "@/mixins/numbers";

export default {
  name: "ProfitLosses",
  mixins: [NumbersMixin],
  computed: {
    changePercFromHourAgo_display() {
      return this.getChange("changePercFromHourAgo");
    },
    changeFromHourAgo_display() {
      return this.getChange("changeFromHourAgo");
    },
    changePercFrom24HoursAgo_display() {
      return this.getChange("changePercFrom24HoursAgo");
    },
    changeFrom24HoursAgo_display() {
      return this.getChange("changeFrom24HoursAgo");
    },
    changePercFrom7DaysAgo_display() {
      return this.getChange("changePercFrom7DaysAgo");
    },
    changeFrom7DaysAgo_display() {
      return this.getChange("changeFrom7DaysAgo");
    },
    ...mapGetters({
      incognitoMode: "settings/incognitoMode",
      profitlossMode: "settings/profitlossMode",

      changePercFromHourAgo: "portfolio/changePercFromHourAgo",
      changeFromHourAgo: "portfolio/changeFromHourAgo",
      changePercFrom24HoursAgo: "portfolio/changePercFrom24HoursAgo",
      changeFrom24HoursAgo: "portfolio/changeFrom24HoursAgo",
      changePercFrom7DaysAgo: "portfolio/changePercFrom7DaysAgo",
      changeFrom7DaysAgo: "portfolio/changeFrom7DaysAgo",

      profitlossShowHistory: "profitloss/showHistory",
      changePercFromHourAgo_pl: "profitloss/changePercFromHourAgo",
      changeFromHourAgo_pl: "profitloss/changeFromHourAgo",
      changePercFrom24HoursAgo_pl: "profitloss/changePercFrom24HoursAgo",
      changeFrom24HoursAgo_pl: "profitloss/changeFrom24HoursAgo",
      changePercFrom7DaysAgo_pl: "profitloss/changePercFrom7DaysAgo",
      changeFrom7DaysAgo_pl: "profitloss/changeFrom7DaysAgo",
    }),
  },
  methods: {
    isNegative(field) {
      return ["Table__Amount", field < 0 ? "Table__Amount--Negative" : ""];
    },
    getChange(name) {
      const sufix = this.profitlossMode ? "_pl" : "";
      return this[name + sufix];
    },
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";

.Table {
  margin: 0;
  width: 100%;
  font-size: 18px;
  font-weight: 300;
}

.Table__Row {
  border-bottom: 1px solid #ebebeb;

  &:last-child {
    border-bottom: 0;
  }
}

.Table__Range {
  font-weight: 700;
}

.Table__Amount,
.Table__Range {
  padding: 12px 0;
  white-space: nowrap;
}

.Table__Amount {
  color: $color-tertiary;
  text-align: right;

  &--Negative {
    color: $color-primary;
  }
}
</style>
